import * as yup from 'yup';

export const forgotPassSchema = yup.object({
    email: yup.string()
        .email('El correo electrónico no es válido')
        .required('El correo electrónico es obligatorio'),
});